
import { Vue, Options } from "vue-class-component";
import RDAnalyticsChart from "./RDAnalyticsChart.vue";
import PDAnalyticsChart from "./PDAnalyticsChart.vue";
import PMAnalyticsChart from "./PMAnalyticsChart.vue";
import HumanSkillChart from "../atoms/HumanSkillChart.vue";
import PersonalityMatrixChart from "./PersonalityMatrixChart.vue";
import ProgressChart from "../molecules/ProgressChart.vue";
import People from "../pages/People.vue";
@Options({
  components: {
    RDAnalyticsChart,
    PDAnalyticsChart,
    PMAnalyticsChart,
    HumanSkillChart,
    People,
    PersonalityMatrixChart,
    ProgressChart
  }
})
/* eslint-disable */
export default class Print extends Vue {
  target = "";
  data?: any = null;
  options?: any = null;
  windowWidth!: number;
  windowHeight!: number;
  userName?: string;
  beforeCreate() {
    this.target = localStorage.getItem("printTarget")!;
  }
  beforeMount() {
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
  }
  mounted() {
    this.$nextTick(() => {
      this.data = JSON.parse(localStorage.getItem("printData")!);
      this.options = JSON.parse(localStorage.getItem("printOptions")!);
      if (this.options && this.target === "Progress") {
        this.options.plugins.tooltip.callbacks = {
          title: (tooltipItems: any) => {
            const title = tooltipItems[0].label.replaceAll(",", "").replaceAll("丨", "ー");
            return title;
          }
        };
      }
    });
  }
}
/* eslint-enable */
